import React from 'react';
import PropTypes from 'prop-types';
import Global from '../../global';

class EmptyContent extends React.Component {

  render() {

    Global.logger.debug(`Empty content for route ${this.props.match.url}`);
    return (
      <div>
        <p style={{ 'display': 'none' }}>empty content</p>
      </div>
    );
  }
}

EmptyContent.propTypes = {
  match: PropTypes.object
};

export default EmptyContent;
